import Styles from './styles.module.css';
import React, { useState } from 'react';
import NoIndex from '../../../components/NoIndex';
import Icon from './../../../image/icon_black.png';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { CompanyData } from 'src/type';
import Judging from '../16.judging/index';
import ChangePassword from './ChangePassword';

type Props = {
  company: CompanyData;
};

// 審査員（company.role === 'judge'）専用の最小シェル。
// src/salon/desktop/index.tsx の全機能サイドバー・内部Routesを一切経由せず、
// どのURLパスであっても常にこのシェル＋審査ページだけを表示する
// （審査員が /service/recruit 等に直接アクセスしても他機能には到達できない、という
// スコープ制限そのものがこのコンポーネントの存在理由）。
const JudgeShell: React.FC<Props> = ({ company }) => {

  const auth = getAuth();
  const navigate = useNavigate();

  const [ changePasswordOpen, setChangePasswordOpen ] = useState(false);

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/company/login', { replace: true });
  };

  return (
    <>
      <NoIndex title="審査 | memorii works" />
      <div className={Styles.root}>
        <header className={Styles.header}>
          <div className={Styles.headerLeft}>
            <img src={Icon} alt="memorii works" className={Styles.logo} />
            <span className={Styles.title}>memorii works</span>
          </div>
          <div className={Styles.headerRight}>
            <span className={Styles.session}>{company.name}／{company.judgeName} 様</span>
            <button type="button" className={Styles.passwordButton} onClick={() => setChangePasswordOpen(true)}>パスワード変更</button>
            <button type="button" className={Styles.logoutButton} onClick={handleLogout}>ログアウト</button>
          </div>
        </header>
        <main className={Styles.main}>
          <Judging />
        </main>
      </div>

      {changePasswordOpen && <ChangePassword onClose={() => setChangePasswordOpen(false)} />}
    </>
  );
};

export default JudgeShell;
